import {
  CLEAN_FILTERS,
  DELETE_FILTER, LOAD_FILTERS_ERROR, LOAD_FILTERS_LIMBO, LOAD_FILTERS_REQUEST, LOAD_FILTERS_SUCCESS, RELOAD_DATA,
  TOGGLE_FILTER, TOGGLE_IS_SCORE
} from "./filters-action-types";

export const loadFiltersRequest = reportUrl => ({ type: LOAD_FILTERS_REQUEST, reportUrl});
export const loadFiltersSuccess = filters => ({ type: LOAD_FILTERS_SUCCESS, filters});
export const loadFiltersError = error => ({ type: LOAD_FILTERS_ERROR, error });

export const toggleFilter = ({ filterIndex, containerIndex, all }) => (
  { type: TOGGLE_FILTER, filterIndex, containerIndex, all }
);

export const deleteFilter = index => ({ type: DELETE_FILTER, index });

export const reloadData = () => ({ type: RELOAD_DATA });

export const toggleIsScore = filterIndex => ({ type: TOGGLE_IS_SCORE, filterIndex });

export const cleanFilters = () => ({ type: CLEAN_FILTERS });
export const loadFiltersLimbo = () => ({ type: LOAD_FILTERS_LIMBO });


// WEBPACK FOOTER //
// ./src/modules/filters/filters-action-creators.js